import AdminRouteSelector, { AdminRoute } from "@app/components/admin-route-selector.tsx";
import PageTitle from "@app/components/page-title.tsx";
import { Box } from "@mui/material";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin/admin")({
    component: Component,
});

const routes: AdminRoute[] = [
    { to: "/admin/assignment", name: "Assignment Related Tables" },
    { to: "/admin/expense", name: "Expense Related Tables" },
    { to: "/admin/other", name: "Other Tables" },
    { to: "/admin/power-bi", name: "Power BI" },
];

function Component() {
    return (
        <>
            <PageTitle suppressBackButton>Admin</PageTitle>
            <Box display={"flex"} flexDirection={"row"} gap={2} flexWrap={"wrap"}>
                <AdminRouteSelector routes={routes} />
                <Outlet />
            </Box>
        </>
    );
}
